// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "bar-xinglet-843b477e/chunk-" + {"410": "3ece61f40f78f14c","559": "4a075ccad3bd1e4d","937": "a0752bd7fc4ec56b",}[chunkId] + ".js"
}